module.exports = __webpack_public_path__ + "media/application/assets/images/company/stakeholders/arrow_up-aace4d37eb668e154e28f8681796f81f.svg";